import _ from 'lodash';
import { join } from './strings';

export const mapCustomerAddressToDropdown = (customerAddress) => {
  if (!customerAddress) return [];

  return _.values(customerAddress);
};

export const mapCustomerAddressesFromJSON = (addressFromJSON) => {
  if (!addressFromJSON) return {};
  return {
    name: addressFromJSON.n,
    name2: addressFromJSON.n2,
    shipToCode: addressFromJSON.shipToCode,
    city: addressFromJSON.c,
    postalCode: addressFromJSON.p,
    country: addressFromJSON.co,
    state: addressFromJSON.s,
    street: join({
      part1: addressFromJSON.a1,
      part2: addressFromJSON.a2,
      separator: ',',
    }),
  };
};
